<template>
  <footer class="site-footer">
    <div class="footer-inner">
      <div class="footer-brand">
        <span class="footer-logo">云知微</span>
        <p class="footer-copy">© 2026 WeData. All rights reserved.</p>
        <p class="footer-icp">
          <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">浙ICP备2026040675</a>
        </p>
      </div>

      <div class="footer-wechat" @click="openQr">
        <img
          :src="wechatQr"
          alt="客服微信二维码"
          class="footer-qr-thumb"
        />
        <span class="footer-qr-label">添加客服微信</span>
      </div>

      <div class="footer-links">
        <a href="#">关于我们</a>
        <router-link to="/policy/contact">联系方式</router-link>
        <router-link to="/policy/user-agreement">用户协议</router-link>
        <router-link to="/policy/privacy">隐私条款</router-link>
      </div>
    </div>

    <transition name="qr-overlay">
      <div v-if="qrVisible" class="qr-overlay" @click.self="closeQr">
        <transition name="qr-zoom">
          <div v-if="qrVisible" class="qr-modal" @click.stop>
            <img :src="wechatQr" alt="客服微信二维码" class="qr-modal-img" />
            <p class="qr-modal-tip">添加客服微信</p>
            <button type="button" class="qr-close" aria-label="关闭" @click="closeQr">
              <i class="el-icon-close"></i>
            </button>
          </div>
        </transition>
      </div>
    </transition>
  </footer>
</template>

<script>
import wechatQr from '@/assets/images/wechat-qr.png'

export default {
  name: 'SiteFooter',
  data() {
    return {
      wechatQr,
      qrVisible: false
    }
  },
  methods: {
    openQr() {
      this.qrVisible = true
      document.body.style.overflow = 'hidden'
    },
    closeQr() {
      this.qrVisible = false
      document.body.style.overflow = ''
    }
  },
  beforeDestroy() {
    document.body.style.overflow = ''
  }
}
</script>

<style scoped>
.site-footer {
  padding: 32px 24px;
  border-top: 1px solid #e5e7eb;
  background: #f9fafb;
}

.footer-inner {
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
}

.footer-brand {
  flex: 1;
  min-width: 0;
}

.footer-logo {
  font-size: 16px;
  font-weight: 600;
  color: #374151;
}

.footer-copy {
  font-size: 13px;
  color: #9ca3af;
  margin-top: 4px;
}

.footer-icp {
  margin: 6px 0 0;
  font-size: 12px;
}

.footer-icp a {
  color: #9ca3af;
  text-decoration: none;
}

.footer-icp a:hover {
  color: #6b7280;
}

.footer-wechat {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  user-select: none;
  transition: transform 0.2s ease;
}

.footer-wechat:hover {
  transform: translateY(-2px);
}

.footer-wechat:hover .footer-qr-thumb {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

.footer-qr-thumb {
  width: 72px;
  height: 72px;
  object-fit: cover;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  background: #fff;
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}

.footer-qr-label {
  font-size: 12px;
  color: #6b7280;
}

.footer-links {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  gap: 24px;
  min-width: 0;
}

.footer-links a,
.footer-links .router-link-active,
.footer-links a:visited {
  font-size: 14px;
  color: #6b7280;
  text-decoration: none;
  transition: color 0.3s;
}

.footer-links a:hover {
  color: #2563eb;
}

/* 遮罩淡入 */
.qr-overlay-enter-active,
.qr-overlay-leave-active {
  transition: opacity 0.25s ease;
}

.qr-overlay-enter,
.qr-overlay-leave-to {
  opacity: 0;
}

.qr-overlay {
  position: fixed;
  inset: 0;
  z-index: 3000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(4px);
}

/* 二维码放大动画 */
.qr-zoom-enter-active {
  animation: qr-zoom-in 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.qr-zoom-leave-active {
  animation: qr-zoom-out 0.22s ease-in forwards;
}

@keyframes qr-zoom-in {
  from {
    opacity: 0;
    transform: scale(0.35);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes qr-zoom-out {
  from {
    opacity: 1;
    transform: scale(1);
  }
  to {
    opacity: 0;
    transform: scale(0.5);
  }
}

.qr-modal {
  position: relative;
  padding: 24px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.2);
  text-align: center;
}

.qr-modal-img {
  display: block;
  width: 240px;
  height: 240px;
  object-fit: cover;
  border-radius: 12px;
}

.qr-modal-tip {
  margin: 14px 0 0;
  font-size: 15px;
  color: #374151;
  font-weight: 500;
}

.qr-close {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 50%;
  background: #f3f4f6;
  color: #6b7280;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  transition: background 0.2s, color 0.2s;
}

.qr-close:hover {
  background: #e5e7eb;
  color: #374151;
}

@media (max-width: 768px) {
  .footer-inner {
    flex-direction: column;
    text-align: center;
  }

  .footer-links {
    justify-content: center;
    flex-wrap: wrap;
    gap: 16px;
  }

  .qr-modal-img {
    width: 200px;
    height: 200px;
  }
}
</style>
